import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maskPhone'
})
export class MaskPhonePipe implements PipeTransform {

    transform(value: string): string {
        if (!value) return '';

        const countryCodeMatch = value.match(/^\+\d+/);
        if (!countryCodeMatch) return value;

        const countryCode = countryCodeMatch[0];
        const rest = value.slice(countryCode.length);

        if (rest.length <= 2) return value;

        const lastTwo = rest.slice(-2);
        const masked = '*'.repeat(rest.length - 2);

        return `${countryCode} ${masked} ${lastTwo}`;
    }
}